// Import model
import { UpdateNoteRequest } from '../models/UpdateNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateNoteRequest instance
   */
  static deserialize(json: string): UpdateNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateNoteRequest instance
   */
  static fromObject(obj: any): UpdateNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateNoteRequest');
    }


    const instance: UpdateNoteRequest = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateNoteRequest instances
   */
  static deserializeArray(json: string): UpdateNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateNoteRequest instance to a JSON string
   */
  static serialize(instance: UpdateNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateNoteRequest instance to a plain object
   */
  static toObject(instance: UpdateNoteRequest): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'contentType': instance.contentType,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateNoteRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
